export class SubjectClassReqModel {
    classId: number;
    subject: number;
    
    constructor(classId: number, subject: number) {
        this.classId = classId;
        this.subject = subject;
    }
}

export class DefaultModelPaperCheckReqModel {
    classId: number;
    subjectId: number;
    mainModelPaperId: number;
    
    constructor(classId: number, subjectId: number,mainModelPaperId: number) {
        this.classId = classId;
        this.subjectId = subjectId;
        this.mainModelPaperId = mainModelPaperId;
    }
}